import { render, staticRenderFns } from "./u-text-field-filled-pill.vue?vue&type=template&id=2114f8ba&scoped=true&"
import script from "./u-text-field-filled-pill.vue?vue&type=script&lang=js&"
export * from "./u-text-field-filled-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2114f8ba",
  null
  
)

export default component.exports